export function createFeenyAction(apiCall) {
  return function(...args) {
    return {
      feeny: {
        apiCall,
        args,
      },
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-feeny/action.js